window.fwSettings = {
  widget_id: 151000000250
}
